<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <BankForm
      v-if="!isLoading"
      :bankData="bank"
      :submitName="$t('edit')"
      v-on:addOrUpdateBank="updateBank()"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import BankForm from "@/components/settings/settingsOther/banks/BankForm.vue";
import createToastMixin from "@/utils/create-toast-mixin";
import Bank from "@/models/settings/settingsOther/banks/Bank";

export default {
  name: "BankEdit",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    BankForm,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      bank: new Bank(),
    };
  },
  props: ["bankToken"],
  methods: {
    async getBankDetails() {
      this.isLoading = true;
      this.bank.bankToken = this.bankToken;
      try {
        let response = await this.bank.getBankDetails(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.bank.fillData(response.data.banksData);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.$router.push({ name: "Banks" }).catch(() => {});
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.$router.push({ name: "Banks" }).catch(() => {});
      }
      this.isLoading = false;
    },
    async updateBank() {
      this.isLoading = true;

      try {
        let response = await this.bank.addOrUpdateBank(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push({ name: "Banks" }).catch(() => {});
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getBankDetails();
  },
};
</script>

<style scoped lang="scss"></style>
